import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Button,
  Radio,
  Label,
  Message,
} from 'semantic-ui-react';
import _ from 'lodash';
import { userConstants } from '../../constants/user.constants';
import { reportScheduleActions } from '../../actions/reportSchedule.actions';
import { reportScheduleKindOptions, reportScheduleFrequencyOptions, weekDayOptions, MANAGER_SCOPED_KINDS } from '../../constants/reportSchedule.constants';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

class ReportScheduleFormScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      schedule: {
        name: '',
        kind: 0,
        frequency: 0,
        dayOfWeek: 1,
        dayOfMonth: 1,
        hourOfDay: 6,
        recipientsCsv: '',
        managerUserId: '',
        enabled: true,
      },
      errors: {},
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    if (match.params.id) {
      dispatch(reportScheduleActions.get(match.params.id))
        .then(() => {
          const schedule = _.mapKeys(this.props.schedule, function (v, k) { return k.charAt(0).toLowerCase() + k.slice(1); });
          this.setState({ schedule });
        });
    }
  }

  handleChange(field, data) {
    const { schedule } = this.state;
    schedule[field] = data;
    this.setState({ schedule });
  }

  isManagerScoped() {
    return MANAGER_SCOPED_KINDS.includes(this.state.schedule.kind);
  }

  validate() {
    const { schedule } = this.state;

    let errors = {};
    let valid = true;

    if (!schedule.name || schedule.name.length === 0) {
      errors.name = "Preencha o nome";
      valid = false;
    }

    const hour = parseInt(schedule.hourOfDay, 10);
    if (isNaN(hour) || hour < 0 || hour > 23) {
      errors.hourOfDay = "Informe um valor entre 0 e 23";
      valid = false;
    }

    if (schedule.frequency === 0) {
      const day = parseInt(schedule.dayOfWeek, 10);
      if (isNaN(day) || day < 0 || day > 6) {
        errors.dayOfWeek = "Escolha um dia da semana";
        valid = false;
      }
    } else {
      const day = parseInt(schedule.dayOfMonth, 10);
      if (isNaN(day) || day < 1 || day > 31) {
        errors.dayOfMonth = "Informe um dia entre 1 e 31";
        valid = false;
      }
    }

    if (!this.isManagerScoped()) {
      const recipients = (schedule.recipientsCsv || '').split(/[,;]/).map(x => x.trim()).filter(x => x.length > 0);
      if (recipients.length === 0) {
        errors.recipientsCsv = "Informe ao menos um e-mail destinatário";
        valid = false;
      } else if (recipients.some(x => !EMAIL_REGEX.test(x))) {
        errors.recipientsCsv = "Há um e-mail inválido na lista";
        valid = false;
      }
    }

    this.setState({ errors });
    return valid;
  }

  handleSubmit() {
    if (!this.validate()) {
      return;
    }

    const { dispatch } = this.props;
    const { schedule } = this.state;
    const payload = {
      ...schedule,
      managerUserId: schedule.managerUserId ? parseInt(schedule.managerUserId, 10) : null,
    };

    if (schedule.id) {
      dispatch(reportScheduleActions.update(schedule.id, payload));
    } else {
      dispatch(reportScheduleActions.create(payload));
    }
  }

  render() {
    const { schedule, errors } = this.state;
    const { me, loading } = this.props;

    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }

    const managerScoped = this.isManagerScoped();

    return (
      <Fragment>
        <h1>Agendamento de Relatório</h1>
        <Form loading={loading} onSubmit={() => this.handleSubmit()}>
          <Form.Input required error={errors.name} label='Nome' value={schedule.name} name='name' type='text' onChange={(e, data) => this.handleChange("name", data.value)} placeholder='Ex: Sessões - Time Comercial' />
          {errors.name && <Label color='red'>{errors.name}</Label>}

          <Form.Select required label='Relatório' value={schedule.kind} name='kind' onChange={(e, data) => this.handleChange("kind", data.value)} options={reportScheduleKindOptions} />

          <Form.Select required label='Frequência' value={schedule.frequency} name='frequency' onChange={(e, data) => this.handleChange("frequency", data.value)} options={reportScheduleFrequencyOptions} />

          {schedule.frequency === 0
            ? <Form.Select required error={errors.dayOfWeek} label='Dia da Semana' value={schedule.dayOfWeek} name='dayOfWeek' onChange={(e, data) => this.handleChange("dayOfWeek", data.value)} options={weekDayOptions} />
            : <Form.Input required error={errors.dayOfMonth} label='Dia do Mês (1-31)' value={schedule.dayOfMonth} name='dayOfMonth' type='number' min={1} max={31} onChange={(e, data) => this.handleChange("dayOfMonth", data.value)} />
          }
          {(errors.dayOfWeek || errors.dayOfMonth) && <Label color='red'>{errors.dayOfWeek || errors.dayOfMonth}</Label>}

          <Form.Input required error={errors.hourOfDay} label='Hora do Envio (0-23)' value={schedule.hourOfDay} name='hourOfDay' type='number' min={0} max={23} onChange={(e, data) => this.handleChange("hourOfDay", data.value)} />
          {errors.hourOfDay && <Label color='red'>{errors.hourOfDay}</Label>}

          {managerScoped
            ? <Fragment>
                <Message size='small'>
                  <Message.Header>Envio automático por gestor</Message.Header>
                  <p>Este relatório é enviado automaticamente para cada gestor com usuários sob sua aprovação, cada um recebendo apenas os dados da sua equipe. Não é necessário informar destinatários.</p>
                </Message>
                <Form.Input label='Restringir a um único gestor (opcional)' value={schedule.managerUserId} name='managerUserId' type='number' onChange={(e, data) => this.handleChange("managerUserId", data.value)} placeholder='Id do usuário gestor - deixe em branco para todos' />
              </Fragment>
            : <Fragment>
                <Form.TextArea required error={errors.recipientsCsv} label='Destinatários (e-mails separados por vírgula ou ponto-e-vírgula)' value={schedule.recipientsCsv} name='recipientsCsv' onChange={(e, data) => this.handleChange("recipientsCsv", data.value)} placeholder='financeiro@empresa.com, diretoria@empresa.com' />
                {errors.recipientsCsv && <Label color='red'>{errors.recipientsCsv}</Label>}
              </Fragment>
          }

          <Form.Input>
            <Radio toggle checked={schedule.enabled} label='Habilitado' onChange={(e, data) => this.handleChange("enabled", data.checked)} />
          </Form.Input>

          <Button primary type='submit'>{schedule.id ? 'Alterar' : 'Criar'} Agendamento</Button>
        </Form>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users, reportSchedule } = state;
  let props = {
    me: users.me || null,
    loading: reportSchedule.loading,
  };

  if (reportSchedule && reportSchedule.schedule) {
    props.schedule = reportSchedule.schedule;
  }

  return props;
}

const connectedReportScheduleFormScreen = connect(mapStateToProps)(ReportScheduleFormScreen);
export { connectedReportScheduleFormScreen as ReportScheduleFormScreen };
